// eslint-disable-next-line import/no-extraneous-dependencies
import { ImageOptions, ProviderGetImage } from '@nuxt/image';
import { withBase, joinURL, parseURL } from 'ufo';

const storyblokCDN = 'https://a.storyblok.com';

/**
 * Extract image dimensions from Storyblok URL
 * URL format: /f/152150/6000x4000/hash/filename.jpg
 */
const extractDimensions = (pathname: string): { width: number; height: number } | null => {
  const match = pathname.match(/\/f\/\d+\/(\d+)x(\d+)\//);
  if (match) {
    return { width: parseInt(match[1], 10), height: parseInt(match[2], 10) };
  }
  return null;
};

export const getImage: ProviderGetImage = (src: string, { modifiers = {}, baseURL: _ }: ImageOptions = {}) => {
  const {
    fit,
    smart,
    width = '0',
    height = '0',
    filters = {},
    format,
    quality,
    focalX,
    focalY,
  } = modifiers;

  const doResize = width !== '0' || height !== '0';
  if (format) {
    filters.format = `${format}`;
  }
  if (quality) {
    filters.quality = `${quality}`;
  }

  const { pathname } = parseURL(src);

  // Handle focal point if percentages are provided
  if (focalX !== undefined && focalY !== undefined) {
    const dimensions = extractDimensions(pathname);
    if (dimensions) {
      // Convert percentage strings to numbers (e.g., "40%" -> 40)
      const xPercent = typeof focalX === 'string' ? parseFloat(focalX) : focalX;
      const yPercent = typeof focalY === 'string' ? parseFloat(focalY) : focalY;

      // Calculate pixel coordinates
      const x = Math.round((dimensions.width * xPercent) / 100);
      const y = Math.round((dimensions.height * yPercent) / 100);

      // Create a 1x1 focal point rectangle at the specified position
      filters.focal = `${x}x${y}:${x + 1}x${y + 1}`;
    }
  }

  const _filters = Object.entries(filters || {}).map((e) => `${e[0]}(${e[1]})`).join(':');
  const options = joinURL(
    fit ? `fit-${fit}` : '',
    doResize ? `${width}x${height}` : '',
    smart ? 'smart' : '',
    _filters ? `filters:${_filters}` : '',
  );
  const url = withBase(joinURL(pathname, '/m/', options), storyblokCDN);

  return {
    url,
  };
};
